import React from 'react'
import _ from 'lodash'

export default ({ errors }) =>
  _.isObject(errors) &&
  !_.isEmpty(errors) && (
    <div className="alert alert-dismissible alert-warning">
      <ul className="auth-validation-errors">
        {_.map(errors, (arr, attribute) =>
          _.map(arr, (msg, index) => (
            <li key={`${attribute}${index}`}>
              <strong>{attribute}</strong> {msg}
            </li>
          ))
        )}
      </ul>
    </div>
  )



// WEBPACK FOOTER //
// ./src/containers/pages/users/validation_errors.js